export * from './ionic4-star-rating.module';
export * from './components/ionic4-star-rating-component';